import { createFileRoute } from '@tanstack/react-router';
import { RolesPage } from '~/modules/roles/roles.components/roles-page';

export const Route = createFileRoute('/_main-layout/roles')({
  component: RolesPage,
});
